import { useReveal } from "@/hooks/useReveal";
import { galleryImages } from "@/data/siteData";

export default function Gallery() {
  const ref = useReveal();
  return (
    <section
      id="gallery"
      ref={ref}
      data-testid="gallery-section"
      className="relative py-20 md:py-28 bg-[#EBE4D8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="reveal text-[11px] tracking-[0.32em] uppercase text-[#5A7365] mb-5">
              Inside Cafe Anh
            </p>
            <h2 className="reveal font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#132A1C] leading-[1.08] tracking-tight max-w-xl">
              Small space, big <span className="italic">welcome</span>.
            </h2>
          </div>
          <p className="reveal max-w-sm text-[#2C4C3B] leading-relaxed">
            Photos straight from the café — the warm light, the slat-wood wall, and
            the coffees we pour every day on Hämeentie 30.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-[14rem] md:auto-rows-[15rem] gap-3 md:gap-4">
          {galleryImages.map((img, i) => (
            <figure
              key={`${img.src}-${i}`}
              data-testid={`gallery-item-${i}`}
              className={`reveal relative overflow-hidden bg-[#F4F0EA] ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-[1.04]"
              />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
